// Bulk starts can still perform work inline. Allow ten minutes, then require
// read-only reconciliation or an explicit idempotent retry; never replay a POST.
export const RUN_START_TIMEOUT_MS = 600000;

export const startRunWithDeadline = async (start, { signal } = {}) => {
  const controller = new AbortController();
  if (signal?.aborted) throw new DOMException('Request cancelled', 'AbortError');
  let rejectCancelled;
  const cancelled = new Promise((_, reject) => { rejectCancelled = reject; });
  const abort = () => { rejectCancelled(new DOMException('Request cancelled', 'AbortError')); controller.abort(); };
  signal?.addEventListener('abort', abort, { once: true });
  let timer;
  const deadline = new Promise((_, reject) => {
    timer = setTimeout(() => {
      reject(Object.assign(new Error('The start could not be confirmed. Check progress before retrying.'), { status: 408, name: 'TimeoutError' }));
      controller.abort();
    }, RUN_START_TIMEOUT_MS);
  });
  try { return await Promise.race([start(controller.signal), deadline, cancelled]); }
  finally { clearTimeout(timer); signal?.removeEventListener('abort', abort); }
};
